// Mock data for Explorer Picks - Football Predictions Website

export const siteConfig = {
  brand: "Explorer Picks",
  tagline: "Professional Football Predictions",
  hero: {
    kicker: "Private Soccer Predictions Club",
    title: "Experience. Precision. Winning Picks.",
    subtitle:
      "Explorer Picks is a private football predictions service run by a single professional tipster with nearly three decades of experience analyzing dropping odds across the world's top leagues.",
    cta: "View Membership",
    ctaSecondary: "See Recent Results",
  },
};

export const homepageStats = {
  winningTipsLastYear: 520,
  activeMembers: 675,
  averageWinRate: 78,
};

export const tipster = {
  name: "Ryan Fletcher",
  country: "Australia",
  age: 52,
  experience: 28,
  fields: "Almost all leagues — Premier League, La Liga, Serie A, Bundesliga, Ligue 1, Eredivisie, and more",
  photo: "https://images.unsplash.com/photo-1649705433263-5c80d699b5f5?w=700&q=75&auto=format&fit=crop",
  bio: `People often ask what is behind the consistent win rate at Explorer Picks, and the answer is simple — dropping odds analysis combined with nearly three decades of hands-on football research. My proprietary system aggregates data other tipsters ignore: line-up leaks, weather patterns, refereeing tendencies, and market movement across regulated bookmakers.

Instead of spreading thin by covering every match on the calendar, I focus only on the games each week that hold real value. When I identify a strong reasoning behind a market move, I back the favored side. When the reasoning is weak, I fade the crowd. This disciplined, solo approach produces the sustained win rate my members rely on.`,
};

export const contactInfo = {
  email: "picks.ryanfetcher@gmail.com",
  supportEmail: "picks.ryanfetcher@gmail.com",
  location: "Australia",
};

export const testimonials = [
  {
    name: "Abel F.",
    role: "Explorer Picks member",
    text:
      "When it comes to analyzing dropping odds, nobody does it better than Ryan. His picks are so consistent and win so often that you'll wonder if he's psychic. He's not — he's just extraordinarily good at what he does.",
  },
  {
    name: "Hamilton W.",
    role: "Explorer Picks member",
    text:
      "As a beginner I tried to do all the match research myself but was quickly overwhelmed. With Explorer Picks, Ryan does all the research for me and simply emails me the best pick each day. Nothing could be easier.",
  },
  {
    name: "Tad M.",
    role: "Explorer Picks member",
    text:
      "Not long after I joined there was a huge match — all my friends were backing one team, but Ryan's tip said the other. I hesitated, then followed the tip, and we won big. I haven't looked back since. Best soccer predictions provider on the internet.",
  },
];

export const faqs = [
  {
    q: "How do I receive the football picks?",
    a: "Once you subscribe to any of the membership plans, the daily pick is delivered directly to your registered email inbox. You will typically receive between 1 and 2 carefully researched picks per day, sent at least 12–24 hours before kick-off so you have plenty of time to place your bets.",
  },
  {
    q: "What leagues does Ryan cover?",
    a: "Explorer Picks covers almost all leagues where value can be found — the major European competitions (Premier League, La Liga, Serie A, Bundesliga, Ligue 1, Champions League, Europa League), the top Scandinavian leagues, selected South American fixtures, and international tournaments whenever the market movement points to real opportunity.",
  },
  {
    q: "Which bookmakers do you recommend?",
    a: "Explorer Picks is not partnered with any single bookmaker and you are free to use whichever regulated sportsbook you prefer. Odds published in the archive are sourced from the market average so you can compare and shop for the best line yourself.",
  },
  {
    q: "How is the win rate calculated?",
    a: "The published win rate reflects every single settled pick over the past 12 months, including losses and pushes. Losing picks are never removed from the archive and every result is verified against the official final score before being published.",
  },
  {
    q: "Is a subscription refundable?",
    a: "Due to the digital, time-sensitive nature of the picks, subscriptions are non-refundable once picks have been delivered. However, every plan includes a replacement match for any losing pick, so you always get the value promised.",
  },
  {
    q: "Can I trust the results archive?",
    a: "Yes. The archive is public, permanent, and updated the moment each match is settled. Losing picks remain visible next to winning picks so that every visitor can independently verify long-term performance.",
  },
  {
    q: "How much should I stake on each pick?",
    a: "Bankroll management is entirely up to you, but most members use flat stakes between 1% and 3% of their bankroll per pick. Please gamble responsibly and never wager more than you can afford to lose.",
  },
  {
    q: "Is Explorer Picks legal in my country?",
    a: "Explorer Picks provides research and picks only — there is no bookmaker operating here. It is your responsibility to ensure that betting on football is legal in your jurisdiction before subscribing.",
  },
];

export const plans = [
  {
    id: "days10",
    name: "10 Days Access",
    price: 100,
    currency: "€",
    period: "10 days",
    features: [
      "Best-value picks delivered by email",
      "1–2 selections per day",
      "Premium odds selections",
      "Priority email support from Ryan",
      "Replacement match for every losing match",
      "Full archive access",
    ],
    highlighted: false,
  },
  {
    id: "days30",
    name: "30 Days Access",
    price: 200,
    currency: "€",
    period: "30 days",
    features: [
      "Best-value picks delivered by email",
      "1–2 selections per day",
      "Premium odds selections",
      "Priority email support from Ryan",
      "Replacement match for every losing match",
      "Full archive access",
    ],
    highlighted: true,
    badge: "MOST POPULAR",
  },
  {
    id: "season",
    name: "Whole Season Pass",
    price: 800,
    currency: "€",
    period: "whole season",
    features: [
      "Best-value picks delivered by email",
      "1–2 selections per day",
      "Premium odds selections",
      "Priority email support from Ryan",
      "Replacement match for every losing match",
      "Full archive access",
    ],
    highlighted: false,
  },
];

export const trialOffer = {
  id: "trial",
  name: "TEST MY TIPS",
  price: 50,
  currency: "€",
  period: "3 days subscription",
  tagline: "Try Ryan's picks with a low-risk trial",
  features: [
    "3 days of daily premium picks",
    "1–2 selections per day",
    "Full replacement match if a pick loses",
    "See if the win rate holds — then upgrade",
  ],
};

export const paymentMethods = [
  { id: "skrill", name: "Skrill" },
  { id: "paypal", name: "PayPal" },
  { id: "crypto", name: "Crypto" },
];

export const adminCredentials = {
  username: "Marko6226",
  password: "Slusamkajsumatsumite6226@",
};
